import { useState, useEffect } from "react";

import yearsAPI from "../data/years";
import makesAPI from "../data/makes";
import modelsAPI from "../data/models";
import trimsAPI from "../data/trims";

export const useYearsMap = () => {
  const [years, setYears] = useState();

  useEffect(() => {
    const callAPI = async () => {
      try {
        const maps = await yearsAPI();
        setYears(maps);
      } catch (err) {
        setYears(err);
      }
    };
    callAPI();
  }, []);

  return [years];
};

export const useMakesMap = (ymmtIds) => {
  const [makes, setMakes] = useState();

  const { yearId } = ymmtIds;

  useEffect(() => {
    const callAPI = async () => {
      try {
        const maps = await makesAPI({ yearId });
        setMakes(maps);
      } catch (err) {
        setMakes(err);
      }
    };
    if (yearId) {
      callAPI();
    }
  }, [yearId]);

  return [makes];
};

export const useModelsMap = (ymmtIds) => {
  const [models, setModels] = useState();
  const { yearId, makeId } = ymmtIds;

  useEffect(() => {
    const callAPI = async () => {
      try {
        const models = await modelsAPI({ yearId, makeId });
        setModels(models);
      } catch (err) {
        setModels(err);
      }
    };
    if (yearId && makeId) {
      callAPI();
    }
  }, [yearId, makeId]);

  return [models];
};

export const useTrimsMap = (ymmtIds) => {
  const [trims, setTrims] = useState();
  const { yearId, makeId, modelId } = ymmtIds;

  useEffect(() => {
    const callAPI = async () => {
      try {
        const trims = await trimsAPI({ yearId, makeId, modelId });
        setTrims(trims);
      } catch (err) {
        setTrims(err);
      }
    };
    if (yearId && makeId && modelId) {
      callAPI();
    }
  }, [yearId, makeId, modelId]);

  return [trims];
};

const useYMMTMaps = (ymmtIds) => {
  const [years] = useYearsMap();
  const [makes] = useMakesMap(ymmtIds);
  const [models] = useModelsMap(ymmtIds);
  const [trims] = useTrimsMap(ymmtIds);

  return [{ years, makes, models, trims }];
};

export default useYMMTMaps;
